import styled from "styled-components";
import { Typography } from "@mui/material";
import CallMadeIcon from "@mui/icons-material/CallMade";
import CallReceivedIcon from "@mui/icons-material/CallReceived";
import {
  pressable,
  staggeredFadeInUp,
} from "../../utils/globalStyles/animations";

const SENT_COLOR = "#e53935"; /* vermelho: saída */
const RECEIVED_COLOR = "#28a745"; /* verde: entrada */

export const Card = styled.div<{ $index: number; $clickable: boolean }>`
  width: 100%;
  background-color: #ffffff;
  border-radius: 12px;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  border: 1px solid rgba(0, 0, 0, 0.05);
  display: flex;
  align-items: center;
  gap: 12px;
  box-sizing: border-box;
  ${({ $index }) => staggeredFadeInUp($index)}
  ${({ $clickable }) => $clickable && pressable}
`;

export const IconCircle = styled.div<{ $sent: boolean }>`
  width: 40px;
  height: 40px;
  flex-shrink: 0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ $sent }) =>
    $sent ? "rgba(229, 57, 53, 0.1)" : "rgba(40, 167, 69, 0.1)"};
`;

export const SentIcon = styled(CallMadeIcon)`
  color: ${SENT_COLOR};
  font-size: 20px !important;
`;

export const ReceivedIcon = styled(CallReceivedIcon)`
  color: ${RECEIVED_COLOR};
  font-size: 20px !important;
`;

export const InfoGroup = styled.div`
  flex: 1;
  min-width: 0; /* permite cortar nomes longos com reticências */
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Name = styled(Typography)`
  font-weight: 700 !important;
  color: #333333;
  font-size: 15px !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const SubInfo = styled(Typography)`
  color: #888888;
  font-size: 12px !important;
  font-weight: 500 !important;
`;

export const ValueGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 2px;
  flex-shrink: 0;
`;

export const Value = styled(Typography)<{ $sent: boolean }>`
  font-weight: 800 !important;
  color: ${({ $sent }) => ($sent ? SENT_COLOR : RECEIVED_COLOR)};
  font-size: 17px !important;
`;

export const Time = styled(Typography)`
  color: #aaaaaa;
  font-size: 11px !important;
`;
